import { axios } from "@/client/libs/axios";
import { FilterUserType, UserWithSecrets } from "@reactive-resume/dto";
import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import qs from "qs";

export const getFilterAdmin = async (page?: number, filter?: FilterUserType | null) => {
  if (filter) {
    const user = await axios.get<
      { page: number; data: UserWithSecrets[] },
      AxiosResponse<{ page: number; data: UserWithSecrets[] }>
    >("user", {
      params: {
        page: page,
        isInternal: { equals: true },
        ...filter,
      },
      paramsSerializer: (params) => {
        const filterParams = qs.stringify(params);
        sessionStorage.setItem("Current_admin_list", filterParams);
        return filterParams;
      },
    });
    return user.data;
  }

  const user = await axios.get<
    { page: number; data: UserWithSecrets[] },
    AxiosResponse<{ page: number; data: UserWithSecrets[] }>
  >("/user", {
    params: {
      page: page,
      isInternal: { equals: true },
    },
    paramsSerializer: (params) => {
      const filterParams = qs.stringify(params);
      sessionStorage.setItem("Current_admin_list", filterParams);
      return filterParams;
    },
  });

  return user.data;
};

export const useFilterAdmin = (page?: number, filter?: FilterUserType | null) => {
  const { data: filterAdmin, error } = useQuery({
    queryKey: ["filter-admin", page, filter],
    queryFn: () => getFilterAdmin(page, filter),
  });

  return { filterAdmin, error };
};

export const getAllAdmin = async (page: number) => {
  const response = await axios.get<
    { page: number; data: UserWithSecrets[] },
    AxiosResponse<{ page: number; data: UserWithSecrets[] }>
  >("/user", {
    params: {
      page: page,
      role: { equals: 0 },
    },
  });
  return response.data;
};

export const useAllAdmin = (page: number) => {
  const { data: users, error } = useQuery({
    queryKey: ["all-admin", page],
    queryFn: () => getAllAdmin(page),
  });

  return { users, error };
};
